// Import the SearchTabs component to allow the user to switch between the MPRN and Address search tabs.
import { useGaslinkMeterSearch } from "../../hooks/useGaslinkMeterSearch";

import AddressSearch from "./AddressSearch";
import MprnSearch from "./MprnSearch";
import SearchTabs from "./SearchTabs";
// Import the MprnSearch component to allow the user to fetch meter details using an MPRN.
// Import the AddressSearch component to allow the user to fetch meter details using an address.

// Import a custom hook that encapsulates active tab state and admin access for the 'Address' tab.

const GaslinkMeterSearch: React.FC = () => {
  const { isAdmin, activeTab, setActiveTab } = useGaslinkMeterSearch();

  return (
    <div>
      <h1>Gas Meter Search</h1>
      <div className="meter-search-container">
        {/* Render the SearchTabs component with the active tab state and change handler to allow the user to switch between MPRN and Address search. */}
        <SearchTabs activeTab={activeTab} onTabChange={setActiveTab} isAdmin={isAdmin} />

        {/* Each search component is always mounted to retain state across tab switches. The Bootstrap 'd-none' class (display: none) hides the inactive tab. */}
        <div className={activeTab !== "mprn" ? "d-none" : ""}>
          <MprnSearch />
        </div>

        {/* The 'AddressSearch' is only mounted for admin users. Once mounted, d-none keeps it mounted across tab switches to preserve state. */}
        {isAdmin && (
          <div className={activeTab !== "address" ? "d-none" : ""}>
            <AddressSearch />
          </div>
        )}
      </div>
    </div>
  );
};

export default GaslinkMeterSearch;
